import { ChangeEvent, useEffect, useState } from "react"

import { MbaConfiguration } from "models/mba"
import { MutateOptions } from "react-query"
import { Switch } from "@material-ui/core"
import { css } from "@emotion/css"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

type Props = {
  data: MbaConfiguration | undefined
  id: string | undefined
  update: (
    variables: MbaConfiguration,
    options?:
      | MutateOptions<MbaConfiguration, MbaConfiguration, Error, unknown>
      | undefined,
  ) => void
}

export function VersionTrackerToggle(props: Props) {
  const { hasAuthority } = useAuthenticated()
  const { update, id, data } = props
  const { t } = useI18n()
  const [toggleStatus, setToggleStatus] = useState<boolean | undefined>(false)

  const handleChange = (
    _: ChangeEvent<HTMLInputElement>,
    checked?: boolean,
  ) => {
    update({
      id: id,
      versionTrackerIncluded: checked,
    })
    setToggleStatus(checked)
  }

  useEffect(() => {
    data?.versionTrackerIncluded !== toggleStatus &&
      setToggleStatus(!!data?.versionTrackerIncluded)
  }, [data, toggleStatus])

  return (
    <div className={styles.container}>
      <h5 className="BodyBody-1BlackBold">
        {t("mba-configuration.version-tracker.toggle")}
      </h5>
      <Switch
        color="primary"
        checked={toggleStatus}
        onChange={handleChange}
        disabled={!hasAuthority(["AUTH_EDIT_MBA_CONFIG"])}
      />
    </div>
  )
}

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
}
